import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-patient-info-card',
  standalone: false,
  
  templateUrl: './patient-info-card.component.html',
  styleUrl: './patient-info-card.component.scss'
})
export class PatientInfoCardComponent {

  @Input() patient: {
    firstName: string,
    lastName: string,
    age: number,
    gender: "Male" | "Female"
  };

}
